import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import {
  fetchNewRequestVehiclesAsync,
  setVehicleType,
} from "../../redux/newRequest/newRequest.actions";
import { selectVehicleType } from "../../redux/newRequest/newRequest.selectors";
import { createStructuredSelector } from "reselect";
import {
  MainStyled,
  DisableVehivle,
  EnableVehivle,
  IconContainer,
  BtnStyled,
} from "./vehicleCategory.styles";
import Arrow from "../../assets/img/icn-leftarrow-drk.svg";
import Car from "../../assets/img/vehicles/type_02_drk@60.svg";
import Motor from "../../assets/img/vehicles/type_01_drk@60.svg";
import Vanet from "../../assets/img/vehicles/type_03_drk@60.svg";
import VanetSangin from "../../assets/img/vehicles/type_04_drk@60.svg";
import Kamionet from "../../assets/img/vehicles/type_05_drk@60.svg";
import Kamion from "../../assets/img/vehicles/type_07_drk@60.svg";
import Tereyli from "../../assets/img/vehicles/type_08_drk@60.svg";
import socket from "../../assets/socketConnection";
import CarSelection from "../carSelection/carSelection.component";

import './styles.css'

const VehicleCategory = ({ setVehicleType, selectVehicleType }) => {
  const history = useHistory();
  const [step, setStep] = useState(0);

  const dispatch = useDispatch();

  const mm = (e) => {
    setVehicleType(e);
    dispatch(fetchNewRequestVehiclesAsync(socket));
    setStep(1);

    console.log("emam", e);
    console.log("emam", selectVehicleType);
  };
  return (
    <div>
    
      <MainStyled>
        {step === 0 ? (
          <>
            {/* <Link to="/app2/new-req"> */}
            <EnableVehivle onClick={() => mm("light")}>
              <div className="d-flex align-items-center">
                <div
                  style={{
                    fontSize: "14px",
                    fontWeight: "bold",
                    marginRight: "6px",
                  }}
                >
                  سبک و کوچک
                </div>
                <div className="mr-2" style={{ fontSize: "10px" }}>
                  بسته های داخل شهری
                </div>
              </div>
              <div
                className="mt-1"
                style={{ fontSize: "12px", marginRight: "6px" }}
              >
                موتورسیکلت و سواری
              </div>
              <IconContainer>
                <img src={Car} alt="car" />
                <img className="mr-2" src={Motor} alt="motor" />
              </IconContainer>
              <BtnStyled onClick={() => mm("light")}>
                <div style={{ width: "90%", cursor: "pointer" }}>
                  انتخاب کنید
                </div>
                <img src={Arrow} alt="arrow" />
              </BtnStyled>
            </EnableVehivle>
            {/* </Link> */}

            {/* <Link to="/app2/new-req"> */}
            <EnableVehivle onClick={() => mm("medium")}>
              <div
                style={{
                  fontSize: "14px",
                  fontWeight: "bold",
                  marginRight: "6px",
                }}
              >
                نیمه سنگین و متوسط
              </div>
              <div
                className="d-flex align-items-center mt-2"
                style={{ marginRight: "6px" }}
              >
                <div style={{ fontSize: "12px" }}>
                  وانت سبک و سنگین و کامیونت
                </div>
                <div
                  className="mr-2"
                  style={{ fontSize: "10px", opacity: "0.5" }}
                >
                  بارهای داخل و بین شهری
                </div>
              </div>
              <IconContainer>
                <img src={Kamionet} alt="kamionet" />
                <img
                  className="mr-2 ml-2"
                  src={VanetSangin}
                  alt="vanetsangin"
                />
                <img src={Vanet} alt="vanet" />
              </IconContainer>
              <BtnStyled onClick={() => mm("medium")}>
                <div style={{ width: "90%", cursor: "pointer" }}>
                  انتخاب کنید
                </div>
                <img src={Arrow} alt="arrow" />
              </BtnStyled>
            </EnableVehivle>
            {/* </Link> */}

            {/* <Link to="/app2/new-req"> */}
            <EnableVehivle onClick={() => mm("heavy")}>
              <div
                style={{
                  fontSize: "14px",
                  fontWeight: "bold",
                  marginRight: "6px",
                }}
              >
                سنگین و بزرگ
              </div>
              <div
                className="d-flex align-items-center mt-2"
                style={{ marginRight: "6px" }}
              >
                <div style={{ fontSize: "12px" }}>کامیون و تریلی</div>
              </div>
              <IconContainer>
                <img
                  className="mr-2 ml-2"
                  style={{ width: "140px" }}
                  src={Tereyli}
                  alt="vanetsangin"
                />
                <img src={Kamion} alt="kamionet" />
              </IconContainer>
              <BtnStyled onClick={() => mm("heavy")}>
                <div style={{ width: "90%", cursor: "pointer" }}>
                  انتخاب کنید
                </div>
                <img src={Arrow} alt="arrow" />
              </BtnStyled>
            </EnableVehivle>
            {/* </Link> */}

            {/* <Link to="/app2/new-req"> */}
            <EnableVehivle onClick={() => mm("none")}>
              <div
                style={{
                  fontSize: "14px",
                  fontWeight: "bold",
                  marginRight: "6px",
                }}
              >
                هر نوع خودرو
              </div>
              <div
                className="d-flex align-items-center mt-2"
                style={{ marginRight: "6px" }}
              >
                <div style={{ fontSize: "12px" }}>
                  نمی دانم که چه خودرویی نیاز دارم
                </div>
              </div>
              <BtnStyled onClick={() => mm("none")}>
                <div style={{ width: "90%", cursor: "pointer" }}>
                  انتخاب کنید
                </div>
                <img src={Arrow} alt="arrow" />
              </BtnStyled>
            </EnableVehivle>
            {/* </Link> */}
          </>
        ) : (
          <>
            <button
              onClick={() => setStep(0)}
              className="text-center mr-auto mb-3 btn btn-warning "
              style={{ width: "100px" }}
            >
              بازگشت
            </button>
            <div
              onClick={(e) => {
                if (!e.target.classList.contains("overflow-hidden")) {
                  setTimeout(() => {
                    history.push("/app2/new-req");
                  }, 1000);
                }
              }}
              className="slider-car"
            >
              <CarSelection second />
            </div>
          </>
        )}
      </MainStyled>
    </div>
  );
};
const mapDispatchToProps = (dispatch) => ({
  setVehicleType: (x) => dispatch(setVehicleType(x)),
});
const mapStateToProps = createStructuredSelector({
  selectVehicleType: selectVehicleType,
});
export default connect(mapStateToProps, mapDispatchToProps)(VehicleCategory);
